export const SET_UNREAD_COUNT = '@notifications/SET_UNREAD_COUNT';
export const RESET_UNREAD_COUNT = '@notifications/RESET_UNREAD_COUNT';
